<template>
  <b-card title="POTENZA">
    <Spinner v-if="loading"/>

    <template v-else>
      <div>
        <MonthPicker v-model="date"/>
      </div>

      <div id="power-grid">
        <div>Potenza MAX</div>
        <div>{{ details.max | formatNullableDecimal }} [{{ mu }}]</div>
        <div>
          <Delta v-if="details.max" :value-delta="details.maxDelta"/>
        </div>

        <div>Potenza min</div>
        <div>{{ details.min | formatNullableDecimal }} [{{ mu }}]</div>
        <div>
          <Delta v-if="details.min" :value-delta="details.minDelta"/>
        </div>

        <div>Potenza Media</div>
        <div>{{ details.avg | formatNullableDecimal }} [{{ mu }}]</div>
        <div>
          <Delta v-if="details.avg" :value-delta="details.avgDelta"/>
        </div>
      </div>

      <LastAvailableDataDateLabel v-if="dateFromResponse" :date="dateFromResponse" />
    </template>
  </b-card>
</template>

<script>
import moment from 'moment';
import vectorMixin from './vector';
import { ACTION_POWER } from '@/store/modules/dashboard/actions';

export default {
  name: 'Power',

  mixins: [vectorMixin],

  data() {
    return {
      localDate: moment(),
      dateComparisonType: 'month',
      maxMonthToBeSelected: moment(),

      mu: 'kW',

      details: {
        min: null,
        avg: null,
        max: null,
        minDelta: null,
        avgDelta: null,
        maxDelta: null,
      },
    };
  },

  methods: {
    async loadData(force = false) {
      if (this.loading && !force) {
        return;
      }

      try {
        this.loading = true;

        const { date, ...details } = await this.$store.dispatch(
          `dashboard/${ACTION_POWER}`,
          {
            date: this.date,
          }
        );
        this.details = details;

        if (date) {
          this.setDateFromResponse = true;
          this.localDate = moment(date);
        }
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    monthLabels() {
      return this.$store.state.utils.months;
    },
  },
}
</script>

<style scoped>
#power-grid {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 3fr 1.5fr 1fr;

  padding-top: 15px;
}

#power-grid > div {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/widgets/Power.vue